<template>
  <transition name="slide-x-transition">
      <v-flex xs12 lg6 offset-lg3>
        <v-card class="black">
            <v-list id="list" style="background: #000;" two-line>
            <v-subheader class="white--text">{{ subHeader_1 }}</v-subheader>
                <template v-for="item in states">
                    <router-link
                        id="world_route_btn"
                        :key="item.name"
                        :to="`/account/${currentUser.displayName}/informations/${item.name}`"
                    >
                        <v-list-item :key="item.title">
                        <v-list-item-action>
                            <v-icon size="27.11" :style="item.color">
                            {{
                            item.icon
                            }}
                            </v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title class="white--text">{{ item.title }}</v-list-item-title>
                            <v-list-item-subtitle class="white--text" v-if="item.subtitle">
                            {{
                            item.subtitle
                            }}
                            </v-list-item-subtitle>
                        </v-list-item-content>
                        </v-list-item>
                    </router-link>
                </template>
            </v-list>

            <v-list id="list" style="background: #000;" two-line>
            <v-subheader class="white--text">{{ subHeader_2 }}</v-subheader>
                <template v-for="item in app">
                    
                        <v-list-item :key="item.title">
                        <v-list-item-action>
                            <v-icon size="27.11" :style="item.color">
                            {{
                            item.icon
                            }}
                            </v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title class="white--text">{{ item.title }} {{appVersion}}</v-list-item-title>
                        </v-list-item-content>
                        </v-list-item>
                   
                </template>
            </v-list>

            <v-flex xs10 offset-xs1>
                <div class="center-me black my-5">
                    <v-btn v-if="!deleteOn"  large class="main" @click="deleteOn = true">Delete Account?</v-btn>
                
                    <transition-group name="slide-x-transition">
                    <v-btn key="yes" text class="white--text center-me lred--text" style="width: 100%" v-if="deleteOn" @click="deleteAccount">
                        YES?
                        <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                            <path fill="#FF6059" d="M17 4V6H3V4H6.5L7.5 3H12.5L13.5 4H17M4 19V7H16V19C16 20.1 15.1 21 14 21H6C4.9 21 4 20.1 4 19M19 16H21V18H19V16M19 9H21V14H19V9Z" />
                        </svg>
                    </v-btn>
                    <v-btn key="btn-no" text class="white--text center-me" style="width: 100%" v-if="deleteOn" @click="deleteOn = false">
                        NO!
                    </v-btn>
                  </transition-group>

                  </div>
                  <div v-if="!deleteOn" class="center-me">
                     <v-btn class="white mt-5" @click="$router.go(-1)">Back</v-btn>
                  </div>
            </v-flex>

        </v-card>
      </v-flex>
  </transition>
</template>

<script>
import lList from "@/components/list";
import {mapState} from 'vuex'
import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  name: "settings",
  components: {
    lList
  },
  computed: {
      ...mapState("user", ["currentUser"]),
      ...mapState("app", ["appVersion"])
  },
  data() {
    return {
      deleteOn: false,
      subHeader_1: "General information",
      subHeader_2: "App",
      states: [
        {
          title: "About",
          color: { color: "#fff" },
          subtitle: "More information about us",
          icon: "mdi-information",
          name: "infos",
          actionIcon: "mdi-arrow-right"
        },
        {
          title: "AGB",
          color: { color: "#fff" },
          subtitle: "Our AGB's",
          icon: "mdi-account-box",
          name: "contact",
          actionIcon: "mdi-arrow-right"
        },
        {
          title: "Data Protection & Privacy",
          color: { color: "#fff" },
          subtitle: "We take care of your data",
          icon: "mdi-message-alert",
          name: "feedback",
          actionIcon: "mdi-arrow-right"
        },
        {
          title: "Impressum",
          color: { color: "#fff" },
          subtitle: "What, where we are",
          icon: "mdi-share-variant",
          name: "share",
          actionIcon: "mdi-arrow-right"
        }
      ],
      app: [
        {
          title: "App Version",
          color: { color: "#fff" },
          icon: "mdi-gauge",
          name: "infos",
        },
      ]
    };
  },
  methods: {
     async deleteAccount() {
        var user = firebase.auth().currentUser;
        var setError = ''

        user.delete().then(() => {
            this.$router.push('/login')
        }).catch((error) => {
        // An error happened.
        setError = error
        });
        
        if(setError) {
            var credential;

            user.reauthenticateWithCredential(credential).then(function() {
            // User re-authenticated.
            }).catch(function(error) {
            // An error happened.
            });
        }
      }
  }
};
</script>
